
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  *
  * The source file is located at:
  *   /codebuild/output/src2723206075/src/vl-app/pages/events-test.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useUserAppointments from '@hooks/useUserAppointments';
import { useRouter } from '@hooks/useRouter';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '@actions';
import { useAppointmentStatus } from '@hooks/useAppointmentStatus';
import useIsRestricted from '@hooks/useIsRestricted';

const Child2 = ({ appointment }) => {
  const dispatch = useDispatch();
  const isRestricted = useIsRestricted();
  const [latest, setLatest] = useState({});
  const { base, callStatus, patientStatus, clinicianStatus, delayMins } = useAppointmentStatus(appointment);

  useEffect(() => {
    if (!isRestricted) {
      dispatch(actions.getAppointmentStatus(appointment.appointment_id)).then((initial) => {
        setLatest(initial?.appointment_stati?.[0]);
      });
    }
  }, [appointment.appointment_id, dispatch, isRestricted]);

  return (
    <pre>{JSON.stringify({ base, callStatus, patientStatus, clinicianStatus, delayMins, latest }, undefined, 4)}</pre>
  );
};

const EventsTest = () => {
  const { t } = useTranslation('common');
  const { query } = useRouter();
  const [key, setKey] = useState(1);
  const appointmentId = Number(query?.id || 0);
  const { userAppointments: appointments } = useUserAppointments(
    'USER_APPOINTMENTS',
    { appt_id: appointmentId },
    { refetchOnWindowFocus: false, enabled: !!appointmentId }
  );
  const appointment = (appointments as unknown as any)?.payload?.[0];
  const {
    user: { user_type_code, email }
  } = useSelector((s) => s.auth);

  return (
    <>
      <h1>
        {t('Hello ')}
        {user_type_code}, {email}
      </h1>
      <div>
        <button type="button" onClick={() => setKey((k) => k + 1)} data-testid="remount">
          {t('Remount')}
        </button>
      </div>
      {appointment && <Child2 key={key} appointment={appointment} />}
    </>
  );
};


export const Route = createFileRoute('/events-test')({ component: EventsTest });
